import { HeatmapQueryParams, SpaceQueryParams, OpportunitiesDetailQueryParams } from './routes';
import { paramsToRecord } from './utils';

type payload = ReturnType<typeof paramsToRecord>;

export const heatmapQueryParamValidation = (payload: payload): Partial<HeatmapQueryParams> => {
  const out: HeatmapQueryParams = {};
  if (Array.isArray(payload.elem)) {
    out.elem = 0;
  } else if (payload.elem === undefined) {
    out.elem = undefined;
  } else {
    // We always want to ensure at least one item is selected so that the sidebar is expanded to help customer know
    // that it's clickable.
    out.elem = Math.max(0, parseInt(payload.elem, 10));
  }
  out.filter = payload?.filter === 'true';

  return {
    ...payload, // Keep other items (e.g. dashboard and card filters)
    ...out,
  };
};

export const spaceQueryParamValidation = (payload: payload): Partial<SpaceQueryParams> => {
  const out: SpaceQueryParams = {};
  if (payload.tab === 'library' || payload.tab === 'home') {
    out.tab = payload.tab;
  }
  if (
    payload.type === 'dashboards' ||
    payload.type === 'segments' ||
    payload.type === 'metrics' ||
    payload.type === 'funnels' ||
    payload.type === 'retentions' ||
    payload.type === 'journeys' ||
    payload.type === 'heatmaps'
  ) {
    out.type = payload.type;
  }
  return out;
};

export const opportunitiesQueryParamValidation = (
  payload: payload,
): Partial<OpportunitiesDetailQueryParams> => {
  const out: OpportunitiesDetailQueryParams = {};
  out.legacy = payload.legacy === 'true';
  return out;
};
